export default class ClapprUtils {
  constructor(player) {
    this.player = player;

    const hls = this.getCurrentHlsJsInstance();
    if (hls) {
      hls.on('hlsLevelLoaded', (evt, levelDetails) => this.onHlsLevelLoaded(evt, levelDetails));
    }
  }

  onHlsLevelLoaded(evt, levelDetails) {
    // XXX: there's an odd behavior in hls.js where it fires 2 levelLoaded events in quick
    // succession; the first is the one we want because the 2nd has a mutated "start" to be the
    // startPTS.  so ignore the subsequent one but keep the first.
    if (this._avoidDoubleLevel) {
      //console.log('hlsLevelLoaded - ignoring ',levelDetails.details.fragments.length,' framents');
      return;
    } else {
      this._avoidDoubleLevel = true;
      setTimeout(() => (this._avoidDoubleLevel = false), 2000);

      var mediaOffset = 0.0;
      var mediaSN = levelDetails.details.startSN;
      var firstSN = -1;

      if (levelDetails.details.initSegment !== null) {
        const tagList = levelDetails.details.initSegment.tagList;
        for (var i = 0; i < tagList.length; i++) {
          if (tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
            mediaOffset = parseFloat(tagList[i][1]);
            break;
          }
        }
      }

      this._levelFragments = _.map(levelDetails.details.fragments, (data) => {
        for (var i = 0; i < data.tagList.length; i++) {
          if (data.tagList[i][0] == 'EXT-X-BOXCAST-OFFSET') {
            mediaOffset = parseFloat(data.tagList[i][1]);
            break;
          }
        }
        var position = data.relurl.indexOf('.ts');
        var sn = parseInt(data.relurl.substring(position - 8, position), 10);
        if (firstSN == -1) {
          firstSN = sn;
        }
        return { start: data.start, duration: data.duration, sn: mediaSN + (sn - firstSN) };
      });
      this._mediaOffset = mediaOffset;
      //console.log('hlsLevelLoaded - loaded ',this._levelFragments.length,' fragments');
    }
  }

  getCurrentTime() {
    // XXX: skip the clappr player.getCurrentTime nonsense that attempts to track itself on events,
    // and instead hit the <video> element
    return this.player.core.$el.find('video, audio').get(0).currentTime;
  }

  getCurrentHlsJsInstance() {
    if (!this.player) return null;
    const playback = this.player.core.getCurrentPlayback();
    return playback._hls;
  }

  isUsingHlsJs() {
    try {
      return this.getCurrentHlsJsInstance();
    } catch (e) {
      return false;
    }
  }

  getPlayerSegmentAndOffsetForTime(time) {
    const fragments = this._levelFragments;
    var currentSN = -1;
    var startTime = 0.0;
    for (let i = 0; i < fragments.length; i++) {
      let data = fragments[i];

      // Multiple fragments can belong to the same MPEG-TS file so this captures the start time of
      // the very first fragment of an MPEG-TS file.
      if (currentSN != data.sn) {
        currentSN = data.sn;
        startTime = data.start;
      }

      if (data.start <= time && data.start + data.duration >= time) {
        console.log('Found segment for time [', time, ']: ', data);
        return [data.sn, time - startTime];
      }
    }
    console.warn('Unable to find segment matching time [', time, '] in list: ', fragments);
    return null;
  }

  getMediaAbsoluteTimeForTime(time) {
    return time + this._mediaOffset;
  }
}



// WEBPACK FOOTER //
// ./app/utils/clappr.js